export const en = {
    corporate_tariff: 'Corporate rate',
    tooltip_content: 'With the Yandex corporate rate, you can book a room for a fixed price throughout the year',
};
